module.exports = __webpack_public_path__ + "static/media/project-blog.26cdcebf.jpg";